import * as yup from 'yup';

const schema = yup
  .object({
    full_name: yup.string().required('This field is required'),
  });

export default schema;
